import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { MULTILANGUAGE } from './constants';
import Backend from 'i18next-http-backend';
/** i18next configuration */
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    debug: false,
    fallbackLng: MULTILANGUAGE.en.value,
    interpolation: {
        escapeValue: false,
    },
    load: 'currentOnly',
    supportedLngs: Object.keys(MULTILANGUAGE),
});
export default i18n;
